import { render } from "./OrganismsQualityChart.vue?vue&type=template&id=51f9e9f2&ts=true"
import script from "./OrganismsQualityChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsQualityChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/organisms/OrganismsQualityChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51f9e9f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51f9e9f2', __exports__)) {
    api.reload('51f9e9f2', __exports__)
  }
  
  module.hot.accept("./OrganismsQualityChart.vue?vue&type=template&id=51f9e9f2&ts=true", () => {
    api.rerender('51f9e9f2', render)
  })

}


export default __exports__